import React, { Component } from 'react';
import { css } from 'aphrodite/no-important';
import ReactModal from 'react-modal';
import styles from './Modal.styles';
import Icon from '../icon/Icon';

class Modal extends Component {
  componentDidMount() {
    ReactModal.setAppElement('body');
  }
  render() {
    return (
      <ReactModal
        shouldCloseOnOverlayClick={true}
        {...this.props}
        className={{
          base: css(styles.base, this.props.styles && this.props.styles.base),
          afterOpen: css(styles.afterOpen),
          beforeClose: css(styles.beforeClose)
        }}
        overlayClassName={{
          base: css(styles.overlayBase),
          afterOpen: css(styles.overlayAfterOpen),
          beforeClose: css(styles.overlayBeforeClose)
        }}
      >
        <div className={css(styles.title)}>
          {this.props.title}
          <Icon
            styles={styles.close}
            value="cross"
            onClick={this.props.onRequestClose}
          />
        </div>
        <div className={css(styles.body)}>{this.props.children}</div>
      </ReactModal>
    );
  }
}

export default Modal;



// WEBPACK FOOTER //
// ./src/components/common/modal/Modal.js